/**
 * Data model for a single game record entry in the leaderboard.
 *
 * Each record captures the raw time, undo count, penalized time, and date
 * for a completed (won) game.
 */

export interface GameRecord {
    /** Raw time to complete the game in milliseconds (no penalty). */
    rawTime: number

    /** Number of intentional undo button presses during this game. */
    undoCount: number

    /**
     * Penalized time in milliseconds: rawTime + (undoCount * UNDO_PENALTY_MS).
     * This is the value used for leaderboard ranking.
     */
    penalizedTime: number

    /** ISO date string when the game was won. */
    date: string
}

/** Time penalty per undo in milliseconds (15 seconds). */
export const UNDO_PENALTY_MS = 15_000

/** Maximum number of records to keep on the leaderboard. */
export const MAX_RECORDS = 10
